import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';

export function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <header>
        <h1 className="text-3xl font-semibold text-zinc-900">
          {t('dashboard.welcome', { name: user.firstName })}
        </h1>
        <p className="mt-1 text-sm text-zinc-500">{t('dashboard.subtitle')}</p>
      </header>

      <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <div className="rounded-xl bg-white p-5 shadow-sm ring-1 ring-zinc-200">
          <div className="text-sm font-medium text-zinc-500">{t('dashboard.role')}</div>
          <div className="mt-2 text-2xl font-semibold text-brand-700">
            {t(`roles.${user.role}` as const)}
          </div>
        </div>

        <div className="rounded-xl bg-white p-5 shadow-sm ring-1 ring-zinc-200">
          <div className="text-sm font-medium text-zinc-500">E-mail</div>
          <div className="mt-2 truncate text-base text-zinc-900">{user.email}</div>
        </div>

        <div className="rounded-xl bg-white p-5 shadow-sm ring-1 ring-zinc-200">
          <div className="text-sm font-medium text-zinc-500">ID</div>
          <div className="mt-2 text-base text-zinc-900">#{user.id}</div>
        </div>
      </section>
    </div>
  );
}
